import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import animateScrollTo from 'animated-scroll-to';
import exact from 'prop-types-exact';
import Button from '../../../common/button/Button';

const BLUE_PRIMARY = '#0048B3';

const MenuItem = (props) => {
    const location = useLocation();
    const isActive = location.pathname === props.to;

    const handleCategoryCloseMenu = () => {
        if (props.setIsMenuOpen) {
            props.setIsMenuOpen(false);
        }
    };

    const _handleButtonClick = () => {
        animateScrollTo(0, { speed: 700 });

        if (props.isMenuOpen) {
            handleCategoryCloseMenu();
        }

        if (!props.to) {
            console.error("Erro: 'to' não foi definido em MenuItem", props);

            return;
        }

        if (props.to.startsWith('http')) {
            window.open(props.to, '_blank');

            return;
        }

        if (props.to === '/ouvir-radio-online') {
            props.playLive();
        }

        if (props.action) {
            props.action();
        }
    };

    return (
        <li>
            {props.to.startsWith('http') ? (
                <a
                    href={props.to}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="tw-flex tw-gap-2 tw-transition"
                    style={{
                        color: 'black',
                    }}
                    onClick={handleCategoryCloseMenu}
                >
                    {props.Icon && (
                        <props.Icon size={22} weight="fill" color={isActive ? BLUE_PRIMARY : props.iconColor || 'black'} />
                    )}
                    { props.title }
                </a>
            ) : (
                <Button
                    title={props.title}
                    to={props.to || '#'}
                    className="tw-flex tw-gap-2 tw-transition"
                    style={{
                        color: 'black',
                    }}
                    onClick={_handleButtonClick}
                >
                    {props.Icon && (
                        <props.Icon size={22} weight="fill" color={isActive ? BLUE_PRIMARY : props.iconColor || 'black'} />
                    )}
                    {props.title}
                </Button>
            )}
        </li>
    );
};

const checkForToOrAction = (props, propName, componentName) => {
    if (!props.to && !props.action) {
        return new Error(`Wrong props. One of 'to' or 'action' is required by '${componentName}' component.`);
    }

    return null;
};

MenuItem.propTypes = exact({
    title: PropTypes.string.isRequired,
    to: checkForToOrAction,
    action: checkForToOrAction,
    playLive: PropTypes.func.isRequired,
    Icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    iconColor: PropTypes.string,
    // textColor: PropTypes.string,
    isMenuOpen: PropTypes.bool,
    setIsMenuOpen: PropTypes.func,
});

export default MenuItem;
